import React from 'react';
import { Button } from '@mui/material';

const ExportButton = ({ onClick = () => {}, style = {} }) => (
  <Button
    style={{
      color: '#5597B4',
      border: '2px solid #5597B4',
      borderRadius: 50,
      width: 100,
      height: 39,
      fontSize: 16,
      fontWeight: 500,
      ...style,
    }}
    onClick={onClick}
  >
    匯出資料
  </Button>
);

export default ExportButton;
